import { SIDECAR_ROUTES } from 'src/sidecar-routes.enum';

export const SIDECAR_ROUTE_PARAMS = {
  [SIDECAR_ROUTES.Organization]: {
    id: 'id',
  },
};
